"use client";

import React from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { Stack, Typography, TextField, InputAdornment } from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { RHFInputDecimalField } from "@onair/ui/form-controls/input-decimal";

import { WizardSchemaType } from "../index";

interface PropTypes {
	methods: UseFormReturn<WizardSchemaType>;
}

const PRICING_ONLINE_PREFIX_NAME = "stepPricing.ticketTiers.0";

const EventSessionPricingAll: React.FC<PropTypes> = ({ methods }) => {
	const { unregister, setValue, getValues, control } = methods;

	const isUnlimitedAudiences = useWatch({
		name: `${PRICING_ONLINE_PREFIX_NAME}.isUnlimitedAudiences`,
		control,
	});
	const isFree = useWatch({
		name: `${PRICING_ONLINE_PREFIX_NAME}.isFree`,
		control,
	});
	const hasBeenPaid = getValues(`${PRICING_ONLINE_PREFIX_NAME}.hasBeenPaid`);

	React.useEffect(() => {
		if (isFree) {
			unregister(`${PRICING_ONLINE_PREFIX_NAME}.farePrice`);
			setValue(`${PRICING_ONLINE_PREFIX_NAME}.farePrice`, 0);
		}

		if (isUnlimitedAudiences) {
			setValue(`${PRICING_ONLINE_PREFIX_NAME}.limitAudiences`, undefined, {
				shouldValidate: true
			});
		}
	}, [isFree, isUnlimitedAudiences]);

	return (
		<Stack spacing={3}>
			<Stack spacing={1}>
				<Field.Switch
					name={`${PRICING_ONLINE_PREFIX_NAME}.isUnlimitedAudiences`}
					label={
						<Typography fontWeight={600} variant="body2">
							Không giới hạn sức chứa
						</Typography>
					}
				/>
				{isUnlimitedAudiences ? (
					<TextField
						label="Số người đăng ký"
						required
						value="Không giới hạn"
						disabled
					/>
				) : (
					<RHFInputDecimalField
						name={`${PRICING_ONLINE_PREFIX_NAME}.limitAudiences`}
						label="Số người đăng ký"
						required
					/>
				)}
			</Stack>
			<Stack spacing={1}>
				<Field.Switch
					name={`${PRICING_ONLINE_PREFIX_NAME}.isFree`}
					disabled={hasBeenPaid}
					label={
						<Typography fontWeight={600} variant="body2">
							Vé miễn phí
						</Typography>
					}
				/>
				<RHFInputDecimalField
					disabled={isFree || hasBeenPaid}
					label="Giá vé"
					required
					name={`${PRICING_ONLINE_PREFIX_NAME}.farePrice`}
					InputProps={{
						endAdornment: <InputAdornment position="end"> ₫</InputAdornment>,
					}}
					sx={{
						flex: 1,
						textAlign: "right",
					}}
				/>
			</Stack>
		</Stack>
	);
};

export default EventSessionPricingAll;
